var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "mx-auto" },
    [
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.customers,
          "items-per-page": 30,
          "show-expand": "",
          expanded: _vm.expanded
        },
        on: {
          "update:expanded": function($event) {
            _vm.expanded = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "item.actions",
            fn: function(ref) {
              var item = ref.item
              return [
                _c(
                  "v-btn",
                  {
                    staticClass: "ma-2",
                    attrs: { icon: "", small: "" },
                    on: {
                      click: function($event) {
                        return _vm.addMerch(item)
                      }
                    }
                  },
                  [
                    _c("v-icon", { attrs: { left: "" } }, [
                      _vm._v("mdi-basket-plus")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                item.status >= 1
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "ma-2",
                        attrs: { icon: "", small: "" },
                        on: {
                          click: function($event) {
                            return _vm.edit(item)
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { left: "" } }, [
                          _vm._v("mdi-pencil")
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                item.paymentMethod == "refunded"
                  ? _c(
                      "div",
                      [
                        _c(
                          "v-chip",
                          {
                            attrs: {
                              label: "",
                              color: "gray lighten-4",
                              "text-color": "#999999"
                            }
                          },
                          [_vm._v("\n          Refunded\n        ")]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                item.status != 2
                  ? _c("StatusChip", { attrs: { status: item.status } })
                  : _vm._e()
              ]
            }
          },
          {
            key: "expanded-item",
            fn: function(ref) {
              var headers = ref.headers
              var item = ref.item
              return [
                item.notes || item.merch.length > 0
                  ? _c(
                      "td",
                      { attrs: { colspan: headers.length } },
                      [
                        _c("Bill", {
                          attrs: {
                            items: item.merch,
                            status: item.status,
                            customer_id: item.customer_id
                          }
                        }),
                        _vm._v(" "),
                        _c("p", [_vm._v("Notes: " + _vm._s(item.notes))])
                      ],
                      1
                    )
                  : _vm._e()
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }